import React, { useEffect } from 'react';
import { Button, ButtonGroup } from '@si-armes/dsfr-react';
import { useHistory } from 'react-router-dom';
import { LABELS, STATUT_INVALIDE, STATUT_VALIDE } from 'constants/titreDetention.constants';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { getAPI } from 'store/apiReducer';
import { isEligibleAutorisation } from 'utils/Statuts.MetierAsso.constant';
import FeatureFlippingComponent from '../../../../../components/FeatureFlipping/FeatureFlippingComponent';
import {
    FEATURE_EDITER_CEAF,
    FEATURE_AUTORISATION_ACQUISITION_DETENTION,
} from '../../../../../components/FeatureFlipping/featureFlipping.func';
import {
    ROLE_TIREUR_SPORTIF,
    DROITS_BOUTON_EDITER_CEAF,
    ROLE_METIER_ASSOCIATION,
} from '../../../../../utils/droitsEtRoles.constant';
import { STATUTS_METIER_ASSO } from '../../../../../utils/Statuts.MetierAsso.constant';
import VerifierDroitsComponent from '../../../../../components/VerifierDroits/VerifierDroitsComponent';
import RoutesCeaf from '../../ceaf/routes';
import RoutesTitreDetention from '../../titre-detention/routes';
import usagerClientReducer from '../../../../../store/usagerReducer';
import {
    API_GET_DECLARATIONS_ARMES,
    API_RENOUVELLEMENT_TITRE_DETENTION,
    CONTEXT_GET_DECLARATIONS_ARMES_ALL,
    CONTEXT_RENOUVELLEMENT_TITRE_DETENTION,
} from '../../../../../constants/apiUrls.constants';
import MesDemarchesEnCours from '../mesDemarchesEnCours/MesDemarchesEnCours';
import { getPath } from '../../../../../utils/router';
import { CEAF } from '../../../../../constants/accessibilite.constants';

const MesDemarches = ({
    isLoadingMesDecalationsArmes,
    isRenouvellement,
    getApi,
    dataMesDeclarationsArmesAll,
}) => {
    const history = useHistory();
    const { titreDetention, demanderMultipleAutorisations, multipleAutorisations } =
        dataMesDeclarationsArmesAll ?? {
            declarationArme: [],
            titreDetention: [],
            demanderMultipleAutorisations: false,
            multipleAutorisations: false,
        };

    const { data: dataUsager } = useSelector((state) => state?.profil?.usager);

    const roles = dataUsager?.roles || [];
    const sousStatut = dataUsager?.sousStatut;

    useEffect(() => {
        getApi(
            usagerClientReducer,
            API_RENOUVELLEMENT_TITRE_DETENTION,
            CONTEXT_RENOUVELLEMENT_TITRE_DETENTION,
        );
    }, []);

    useEffect(() => {
        getApi(usagerClientReducer, API_GET_DECLARATIONS_ARMES, CONTEXT_GET_DECLARATIONS_ARMES_ALL);
    }, []);

    // Liste des boutons des titre des detentions
    // Ajouter une nouveau titre de detentions dans la liste
    const listeDemarcheTitreDetention = [
        {
            type: 'autorisation-detention-arme',
            featureName: FEATURE_AUTORISATION_ACQUISITION_DETENTION,
            droits: [ROLE_TIREUR_SPORTIF, ROLE_METIER_ASSOCIATION],
            label: LABELS[
                roles?.includes(ROLE_METIER_ASSOCIATION)
                    ? 'autorisation-detention-arme-metier-asso'
                    : 'autorisation-detention-arme'
            ],
        },
    ];

    const renouvellementAutorisationPossible = () => {
        if (isLoadingMesDecalationsArmes) {
            return false;
        }

        return isRenouvellement;
    };

    const renouvellementAutorisationVisible = (demarche) => {
        const isIndustriel = sousStatut === STATUTS_METIER_ASSO.METIER_MORALE_ESSAIS_INDUSTRIELS;

        if (isIndustriel && multipleAutorisations) {
            return demanderMultipleAutorisations.length > 0 &&
                demanderMultipleAutorisations.length <= 2 &&
                titreDetention.length > 0
                ? "Demander un renouvellement d'autorisation"
                : demarche.label;
        }

        if (
            titreDetention.find((autorisation) =>
                [STATUT_VALIDE, STATUT_INVALIDE].includes(autorisation.statut),
            )
        ) {
            return "Demander un renouvellement d'autorisation";
        }

        return demarche.label;
    };

    return (
        <>
            <h1>Mes démarches</h1>
            <ButtonGroup inline align="right">
                {listeDemarcheTitreDetention.map((demarche) => (
                    // liste des démarches des demandes de detentions
                    <FeatureFlippingComponent
                        key={demarche.type}
                        featureName={demarche.featureName}
                    >
                        <VerifierDroitsComponent droits={demarche.droits}>
                            {isEligibleAutorisation(dataUsager?.sousStatut) && (
                                <Button
                                    data-testid={`mes-demarches-bouton-${demarche.type}`}
                                    disabled={!renouvellementAutorisationPossible()}
                                    variant="secondary"
                                    onClick={() =>
                                        history.push(
                                            getPath(RoutesTitreDetention.subroutes.creer, {
                                                type: demarche.type,
                                            }),
                                        )
                                    }
                                >
                                    {renouvellementAutorisationVisible(demarche)}
                                </Button>
                            )}
                        </VerifierDroitsComponent>
                    </FeatureFlippingComponent>
                ))}

                <FeatureFlippingComponent featureName={FEATURE_EDITER_CEAF}>
                    <VerifierDroitsComponent droits={DROITS_BOUTON_EDITER_CEAF}>
                        <Button
                            name="editer-ceaf"
                            variant="primary"
                            onClick={() => history.push(getPath(RoutesCeaf.subroutes.editer))}
                        >
                            <div>
                                Éditer ma carte européenne d'armes à feu (<abbr>{CEAF}</abbr>)
                            </div>
                        </Button>
                    </VerifierDroitsComponent>
                </FeatureFlippingComponent>
            </ButtonGroup>
            <br />
            <h2 data-testid="mes-demarches-en-cours-titre" className="font-size-lg margin-top-xs">
                Mes démarches en cours
            </h2>
            <MesDemarchesEnCours />
        </>
    );
};

MesDemarches.propTypes = {
    dataMesDeclarationsArmes: PropTypes.shape({
        declarationArme: PropTypes.arrayOf(
            PropTypes.shape({
                uuid: PropTypes.string.isRequired,
                typeDeDemarche: PropTypes.string.isRequired,
                numeroDeDossier: PropTypes.string.isRequired,
                statut: PropTypes.string.isRequired,
                dateDeDepotDemande: PropTypes.string.isRequired,
                statutEnquete: PropTypes.string,
                demandeCertificatMedicalPsychiatrique: PropTypes.bool.isRequired,
            }),
        ),
        titreDetention: PropTypes.arrayOf(
            PropTypes.shape({
                typeTitreDetention: PropTypes.string,
                numero: PropTypes.string,
                statut: PropTypes.string,
                dateDebut: PropTypes.string,
                piecesManquantes: PropTypes.arrayOf(
                    PropTypes.shape({
                        motif: PropTypes.string,
                        type: PropTypes.string,
                    }),
                ),
            }),
        ),
    }),
    dataMesDeclarationsArmesAll: PropTypes.shape({
        declarationArme: PropTypes.arrayOf(
            PropTypes.shape({
                uuid: PropTypes.string.isRequired,
                typeDeDemarche: PropTypes.string.isRequired,
                numeroDeDossier: PropTypes.string.isRequired,
                statut: PropTypes.string.isRequired,
                dateDeDepotDemande: PropTypes.string.isRequired,
                statutEnquete: PropTypes.string,
                demandeCertificatMedicalPsychiatrique: PropTypes.bool.isRequired,
            }),
        ),
        titreDetention: PropTypes.arrayOf(
            PropTypes.shape({
                typeTitreDetention: PropTypes.string,
                numero: PropTypes.string,
                statut: PropTypes.string,
                dateDebut: PropTypes.string,
                piecesManquantes: PropTypes.arrayOf(
                    PropTypes.shape({
                        motif: PropTypes.string,
                        type: PropTypes.string,
                    }),
                ),
            }),
        ),
    }),
    isLoadingMesDecalationsArmes: PropTypes.bool,
    isRenouvellement: PropTypes.bool,
    getApi: PropTypes.func.isRequired,
};

export default connect(
    (state) => {
        const { data: isRenouvellement } = state.titreDetention.renouvellementAutorisationPossible;
        const { isLoading: isLoadingMesDecalationsArmes, data: dataMesDeclarationsArmesAll } =
            state.mesDeclarationsArmes.declarationsArmesAll;
        return {
            isLoadingMesDecalationsArmes,
            dataMesDeclarationsArmesAll,
            isRenouvellement,
        };
    },
    { getApi: getAPI },
)(MesDemarches);
